module.exports = __webpack_public_path__ + "img/ukraine.e31a89b6.svg";